import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
              About the Platform
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-5 leading-tight">
              What Is{' '}
              <span className="text-primary-600 font-heading italic">Hipobuy Spreadsheet</span>?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Hipobuy Spreadsheet is a structured product research resource that helps shoppers discover, organize, and compare products efficiently. Instead of searching through thousands of random pages, users can access categorized information that streamlines the entire shopping research experience.
            </p>

            <div className="space-y-3 mb-6">
              {[
                { icon: 'ri-price-tag-3-line', text: 'Product recommendations across multiple categories' },
                { icon: 'ri-folder-2-line', text: 'Organized category collections for easy browsing' },
                { icon: 'ri-book-open-line', text: 'Comprehensive shopping guides and tutorials' },
                { icon: 'ri-scales-3-line', text: 'Product comparison resources and tools' },
                { icon: 'ri-lightbulb-line', text: 'Expert research tips for smarter buying decisions' },
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{item.text}</span>
                </div>
              ))}
            </div>

            <Link
              to="/hipobuy-spreadsheet-guide/"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
            >
              Read the Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div className="rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20fashion%20items%20neatly%20arranged%20on%20light%20oak%20wooden%20desk%20with%20laptop%20showing%20spreadsheet%2C%20soft%20morning%20light%20from%20window%2C%20modern%20home%20office%20setting%2C%20warm%20productive%20atmosphere%2C%20lifestyle%20photography%20with%20clean%20aesthetic&width=600&height=800&seq=about-img-01-v2&orientation=portrait"
                alt="Organized product research with Hipobuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-2xl overflow-hidden aspect-[3/4] mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20fashion%20accessories%20and%20clothing%20displayed%20on%20light%20pastel%20pink%20backdrop%2C%20bright%20cheerful%20daylight%2C%20playful%20editorial%20photography%2C%20rainbow%20coordinated%20arrangement%2C%20youthful%20energetic%20aesthetic%20with%20soft%20shadows&width=600&height=800&seq=about-img-02-v2&orientation=portrait"
                alt="Hipobuy Spreadsheet shopping categories"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}